import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/ranking', label: '排行榜' },
  { to: '/completed', label: '完结漫画' },
  { to: '/genre', label: '分类大全' },
  { to: '/about', label: '关于我们' },
  { to: '/faq', label: '常见问题' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/genre?q=${encodeURIComponent(kw)}`);
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        {/* Logo */}
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="动漫之家漫画网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl leading-none text-primary-600">动漫之家</span>
          <span className="hidden text-xs font-medium text-foreground-500 sm:inline-block">漫画网</span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {/* Search */}
          <form onSubmit={handleSearch} className="hidden items-center lg:flex" role="search">
            <div className="flex items-center rounded-full border border-background-300 bg-background-100 px-3 py-1.5">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索想追的漫画…"
                className="w-36 bg-transparent px-2 text-sm outline-none placeholder:text-foreground-400"
                aria-label="站内搜索"
              />
            </div>
            <button
              type="submit"
              className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>

          {/* Mobile menu button */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center gap-2" role="search">
            <div className="flex flex-1 items-center rounded-full border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索想追的漫画…"
                className="w-full bg-transparent px-2 text-sm outline-none placeholder:text-foreground-400"
                aria-label="站内搜索"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50"
            >
              搜索
            </button>
          </form>
          <nav className="grid grid-cols-2 gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}